export default "__VITE_ASSET__1e6c1b29__"